import React, { useEffect, useState } from 'react';
import { object, string } from 'yup';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faDownload, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import _ from 'lodash';
import { env } from '~/commons/config';
import { Form, Formik, useFormikContext } from 'formik';
import FormHttpAlert from '~/commons/components/FormHttpAlert.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormHttpSaveBtn from '~/commons/components/FormHttpSaveBtn.jsx';
import PageHttp from '../../../commons/components/PageHttp.jsx';
import { initFormValues } from '../../../commons/helpers';

export const roads = ['形式一：多媒體作品', '形式二：互動遊戲作品'];
export const themes = [
  '「數」說中國成就',
  // '未來大灣區',
  '國家和世界的聯繫',
  // '中國人物中國故事',
];

const buildSchema = (activeCount) => object({
  // subjects: string().required('類別 為必填'),
  theme: string().required('主題 為必填'),
  tools: string().required('採用工具 為必填'),
  // ...Array.from({ length: activeCount }).reduce((acc, __, idx) => {
  //   const key = `readingMaterial${idx + 1}`;
  //   acc[key] = string()
  //     .nullable()
  //     .required(`閱讀材料 ${idx + 1} 為必填`);
  //   return acc;
  // }, {}),
  road: string().required('形式 為必填'),
  formats: string().required('作品類型 為必填'),
  // intro: string()
  //   .required('作品介紹為必填')
  //   .test(
  //     'word-count',
  //     '作品介紹不得少於250字（中文以字計算；英文以詞計算）',
  //     (val) => {
  //       if (!val) return false;
  //       const str = String(val).trim();
  //       const hasCJK = /[\u4E00-\u9FFF]/.test(str);
  //       if (hasCJK) {
  //         const chars = str.replace(/\s+/g, '').length;
  //         return chars > 250;
  //       }
  //       const words = str.split(/\s+/).filter(Boolean);
  //       return words.length > 250;
  //     },
  //   ),
  links: string().required('作品雲端連結 為必填'),
});

const defaults = {
  // subjects: '',
  theme: '',
  tools: '',
  // readingMaterial1: null,
  // readingMaterial2: null,
  // readingMaterial3: null,
  // readingMaterial4: null,
  // readingMaterial5: null,
  road: '',
  formats: '',
  // intro: '',
  links: '',
};
const GroupInfo = () => {
  const { user, school } = env;

  const rawStudents = user.partiStudents || [];
  const students = rawStudents
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);

  return (
    <div
      className="mb-4 p-3 border rounded card shadow-sm"
      style={{ backgroundColor: '#F0F6FF' }}
    >
      <div
        className="card-header text-align-start"
        style={{ backgroundColor: '#F0F6FF' }}
      >
        <span style={{ fontSize: '20px', fontWeight: 700 }}>參賽隊伍信息</span>
      </div>
      <div
        className="card-body"
        style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}
      >
        <div className="row">
          <div className="col-auto" style={{ fontSize: '16px' }}>
            參與學校:
          </div>
          <div className="col-auto" style={{ fontSize: '16px' }}>
            {school && school.title ? school.title.zhhk : '無'}
          </div>
        </div>

        <div className="row">
          <div className="col-auto" style={{ fontSize: '16px' }}>
            團隊人數:
          </div>
          <div className="col-auto" style={{ fontSize: '16px' }}>
            {user.partiStudentsCount}
          </div>
        </div>

        <div className="row align-items-start mb-1">
          <div className="col-auto" style={{ fontSize: '16px' }}>
            參賽學生:
          </div>
          <div className="col-auto d-flex flex-column">
            {_.map(students, (s, i) => (
              <div className="mb-1" key={i}>
                <div style={{ fontSize: '16px' }}>{s}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="row">
          <div className="col-auto" style={{ fontSize: '16px' }}>
            登入帳戶:
          </div>
          <div className="col-auto" style={{ fontSize: '16px' }}>
            {user.username}
          </div>
        </div>
        <div className="row">
          <div className="col-auto" style={{ fontSize: '16px' }}>
            指導老師:
          </div>
          <div className="col-auto" style={{ fontSize: '16px' }}>
            {user.name.full.en}
          </div>
        </div>
      </div>
    </div>
  );
};

const FormThemeReportsManagement = ({ themeReport }) => {
  const [articlesRes, articlesReq] = useHttpStatus();
  const [res, req] = useHttpStatus();

  const { subjects } = env;
  // activeCount controls how many readingMaterial selects are shown (1..5)
  const initialActive = () => {
    if (!themeReport) return 1;
    let highest = 1;
    for (let i = 1; i <= 5; i += 1) {
      if (themeReport[`readingMaterial${i}`]) highest = i;
    }
    return highest;
  };

  const [activeCount, setActiveCount] = useState(initialActive());
  const disabled = !_.isNil(themeReport);
  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingSubmit, setPendingSubmit] = useState(null);
  useEffect(() => {
    if (themeReport) {
      let highest = 1;
      for (let i = 1; i <= 5; i += 1) {
        if (themeReport[`readingMaterial${i}`]) highest = i;
      }
      for (let i = 1; i <= 5; i += 1) {
        if (themeReport[`readingMaterial${i}`]) highest = Math.max(highest, i);
      }
      setActiveCount(highest);
    }
  }, [themeReport]);
  const addMaterial = () => setActiveCount((c) => (c < 5 ? c + 1 : 5));
  useEffect(() => {
    const subject = themeReport?.subjects || '';
    articlesReq({
      url: 'api/quiz/articles',
      params: {
        sort: { title: 1 },
        limit: 10,
        filter: subject ? { subjects: subject } : {},
      },
    });
  }, [themeReport]);

  const downloadRequirement = async () => {
    const f = env.ThemeReportTemplateURL;

    const url = f.url || f;
    const href = url
      && (String(url).indexOf('http') === 0
        ? url
        : `${window.location.origin}${url}`);
    if (!href) return;

    try {
      const resp = await fetch(href, { credentials: 'include' });

      if (!resp.ok) throw new Error('network response was not ok');

      const blob = await resp.blob();
      const name = f.originalname || f.filename || 'requirement.pdf';
      const blobUrl = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (e) {
      // fallback: open in new tab
      window.open(href, '_blank', 'noopener');
    }
  };
  const handleBeforeSubmit = (values, actions) => {
    setPendingSubmit({ values, actions });
    setShowConfirm(true);
  };

  const handleConfirm = async () => {
    if (pendingSubmit) {
      const { values, actions } = pendingSubmit;
      const v = { ...values, submittedAt: new Date() };
      const { status } = await req({
        method: 'post',
        url: 'api/themeReports',
        data: v,
      });
      actions.setSubmitting(false);
      setShowConfirm(false);
      setPendingSubmit(null);
      if (status === 'success') {
        window.location.reload();
      }
    }
  };

  const handleCancel = () => {
    setShowConfirm(false);
    setPendingSubmit(null);
  };
  return (
    <>
      <div
        style={{
          background: 'url(assets/img/themeReportsTeacher-bg.svg)',
          minHeight: '100vh',
        }}
      >
        <div className="container-fluid pt-1">
          <div className="row py-5">
            <div className="col-12 col-md-8 col-lg-8 mb-4">
              <div className="card shadow-sm">
                <div
                  className="card-header text-align-start"
                  style={{
                    fontWeight: 700,
                    fontSize: '20px',
                    color: '#333333',
                  }}
                >
                  提交作品
                  <span
                    style={{
                      color: '#333333',
                      fontSize: '20px',
                      fontWeight: 400,
                      marginLeft: 8,
                    }}
                  >
                    （<span style={{ color: 'red' }}>*</span>為必填）
                  </span>
                </div>
                <div className="card-body p-4">
                  <Formik
                    validationSchema={buildSchema(activeCount)}
                    initialValues={initFormValues(defaults, themeReport, {
                      omitIds: false,
                    })}
                    disabled={disabled}
                    onSubmit={handleBeforeSubmit}
                  >
                    {({
                      values, setFieldValue, dirty, isValid,
                    }) => {
                      const formDisabled = !dirty || !isValid;

                      return (
                        <Form>
                          <PageHttp res={articlesRes}>
                            {(articles) => {
                              const { rows } = articles;
                              return (
                                <>
                                  <FormHttpAlert res={res} />
                                  {/* <div className="form-row">
                                    <div
                                      className="col"
                                      style={{ fontWeight: 700 }}
                                    >
                                      <FormGroup
                                        name="subjects"
                                        as="select"
                                        label="類別 *（只能選其一）"
                                        style={{ backgroundColor: '#F2F2FF' }}
                                        disabled={disabled}
                                        // onChange={(e) => {
                                        //   const v = e.target.value;
                                        //   // set the subject value
                                        //   setFieldValue('subjects', v);
                                        //   // clear any selected reading materials
                                        //   for (
                                        //     let i = 1;
                                        //     i <= activeCount;
                                        //     i += 1
                                        //   ) {
                                        //     setFieldValue(
                                        //       `readingMaterial${i}`,
                                        //       null,
                                        //     );
                                        //   }
                                        // }}
                                        onChange={async (e) => {
                                          const v = e.target.value;
                                          setFieldValue('subjects', v);
                                          // clear any selected reading materials
                                          for (
                                            let i = 1;
                                            i <= activeCount;
                                            i += 1
                                          ) {
                                            setFieldValue(
                                              `readingMaterial${i}`,
                                              null,
                                            );
                                          }
                                          // fetch articles for the selected subject
                                          await articlesReq({
                                            url: 'api/quiz/articles',
                                            params: {
                                              sort: { title: 1 },
                                              limit: 0,
                                              filter: v ? { subjects: v } : {},
                                            },
                                          });
                                        }}
                                      >
                                        <option value=""> - </option>
                                        {_.orderBy(
                                          Object.keys(subjects),
                                          (key) => subjects[key].sort_order || 0,
                                          'asc',
                                        ).map((key) => (
                                          <option key={key} value={key}>
                                            {subjects[key].zhhk}
                                          </option>
                                        ))}
                                      </FormGroup>
                                    </div>
                                  </div> */}
                                  {/* <div className="form-row">
                                    <div className="col-12">
                                      <label
                                        className="d-block"
                                        style={{ fontWeight: 600 }}
                                      >
                                        閱讀材料(最多選5篇)
                                      </label>
                                    </div>
                                    <div
                                      className="col-12"
                                      style={{ fontWeight: 700 }}
                                    >
                                      {Array.from({ length: activeCount }).map(
                                        (__, idx) => {
                                          const i = idx + 1;
                                          const name = `readingMaterial${i}`;

                                          const selected = [];
                                          for (
                                            let k = 1;
                                            k <= activeCount;
                                            k += 1
                                          ) {
                                            const val = values[`readingMaterial${k}`];
                                            if (val && k !== i) selected.push(val);
                                          }
                                          return (
                                            <div key={name} className="mb-3">
                                              <div className="d-flex align-items-center">
                                                <div style={{ flex: 1 }}>
                                                  <FormGroup
                                                    name={name}
                                                    as="select"
                                                    label={`${
                                                      i === 1
                                                        ? '閱讀材料 1 *'
                                                        : `閱讀材料 ${i}`
                                                    }`}
                                                    style={{
                                                      backgroundColor:
                                                        '#F2F2FF',
                                                    }}
                                                    disabled={
                                                      disabled
                                                      || !values.subjects
                                                    }
                                                  >
                                                    <option value="">
                                                      {' '}
                                                      -{' '}
                                                    </option>
                                                    {(() => {
                                                      const currentValue = values[name];
                                                      const hasCurrent = rows.some(
                                                        (a) => a._id
                                                            === currentValue,
                                                      );
                                                      return [
                                                        !hasCurrent
                                                        && currentValue ? (
                                                          <option
                                                            key={currentValue}
                                                            value={currentValue}
                                                          >
                                                            {currentValue}
                                                          </option>
                                                          ) : null,
                                                        ...rows
                                                          .filter((a) => {
                                                            if (
                                                              a._id
                                                              === currentValue
                                                            ) return true;
                                                            if (
                                                              selected.includes(
                                                                a._id,
                                                              )
                                                            ) return false;
                                                            if (
                                                              values.subjects
                                                            ) {
                                                              const s = a.subjects;
                                                              if (!s) return false;
                                                              if (
                                                                Array.isArray(s)
                                                              ) {
                                                                return s.includes(
                                                                  values.subjects,
                                                                );
                                                              }
                                                              return (
                                                                String(s)
                                                                === String(
                                                                  values.subjects,
                                                                )
                                                              );
                                                            }
                                                            return true;
                                                          })
                                                          .map((a) => (
                                                            <option
                                                              key={a._id}
                                                              value={a._id}
                                                            >
                                                              {a.title}
                                                            </option>
                                                          )),
                                                      ];
                                                    })()}
                                                  </FormGroup>
                                                </div>
                                                {!disabled && (
                                                  <div className="ml-2">
                                                    {i > 1 && (
                                                      <button
                                                        type="button"
                                                        className="btn btn-outline-danger"
                                                        aria-label="移除閱讀材料"
                                                        title="移除"
                                                        onClick={() => {
                                                          // shift values down from i+1..activeCount
                                                          for (
                                                            let j = i;
                                                            j < activeCount;
                                                            j += 1
                                                          ) {
                                                            const from = `readingMaterial${
                                                              j + 1
                                                            }`;
                                                            const to = `readingMaterial${j}`;
                                                            setFieldValue(
                                                              to,
                                                              values[from]
                                                                || null,
                                                            );
                                                          }
                                                          // clear last and decrease activeCount
                                                          setFieldValue(
                                                            `readingMaterial${activeCount}`,
                                                            null,
                                                          );
                                                          setActiveCount((c) => Math.max(1, c - 1));
                                                        }}
                                                      >
                                                        <FA icon={faTimes} />
                                                      </button>
                                                    )}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        },
                                      )}
                                    </div>
                                    {!disabled && (
                                      <div className="col-12 d-flex justify-content-center">
                                        {activeCount < 5 && (
                                          <div className="mt-1">
                                            <button
                                              type="button"
                                              className="btn"
                                              onClick={addMaterial}
                                            >
                                              <FA icon={faPlus} />
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div> */}

                                  <div className="form-row">
                                    <div
                                      className="col-12"
                                      style={{ fontWeight: 700 }}
                                    >
                                      <FormGroup
                                        name="theme"
                                        as="select"
                                        label="主題 * (只能選其一）"
                                        style={{ backgroundColor: '#F2F2FF' }}
                                        disabled={disabled}
                                      >
                                        <option value=""> - </option>
                                        {themes.map((t) => (
                                          <option key={t} value={t}>
                                            {t}
                                          </option>
                                        ))}
                                      </FormGroup>
                                    </div>
                                  </div>

                                  <div className="form-row">
                                    <div
                                      className="col-12"
                                      style={{ fontWeight: 700 }}
                                    >
                                      <FormGroup
                                        name="tools"
                                        label="採用工具*（如DeepSeek、ChatGPT、Dreamina Ai、Canva、PowerPoint、CapCut等)"
                                        style={{ backgroundColor: '#F2F2FF' }}
                                        disabled={disabled}
                                      />
                                    </div>
                                  </div>

                                  <div className="form-row">
                                    <div
                                      className="col-12"
                                      style={{ fontWeight: 700 }}
                                    >
                                      <FormGroup
                                        name="road"
                                        as="select"
                                        label="形式*（只能選其一）"
                                        style={{ backgroundColor: '#F2F2FF' }}
                                        disabled={disabled}
                                      >
                                        <option value=""> - </option>
                                        {roads.map((r) => (
                                          <option key={r} value={r}>
                                            {r}
                                          </option>
                                        ))}
                                      </FormGroup>
                                    </div>
                                  </div>

                                  <div className="form-row">
                                    <div
                                      className="col-12"
                                      style={{ fontWeight: 700 }}
                                    >
                                      <FormGroup
                                        name="formats"
                                        label="作品類型*（如選形式一，可填寫資訊圖、影片、AI數字人等；如選形式二，可填寫網上問答遊戲等 ）"
                                        style={{ backgroundColor: '#F2F2FF' }}
                                        disabled={disabled}
                                      />
                                    </div>
                                  </div>
                                  {/* temp remove intro field */}
                                  {/* <div className="form-row">
                                    <div
                                      className="col-12"
                                      style={{ fontWeight: 700 }}
                                    >
                                      <FormGroup
                                        name="intro"
                                        as="textarea"
                                        label="填寫作品介紹*（不少於250字）"
                                        rows={6}
                                        style={{ backgroundColor: '#F2F2FF' }}
                                        disabled={disabled}
                                      />
                                      <div className="d-flex justify-content-end mt-1">
                                        {(() => {
                                          const raw = values.intro || '';
                                          const str = String(raw).trim();
                                          const hasCJK = /[\u4E00-\u9FFF]/.test(
                                            str,
                                          );
                                          let count = 0;
                                          if (hasCJK) {
                                            // count non-whitespace characters for CJK (Chinese)
                                            count = str.replace(
                                              /\s+/g,
                                              '',
                                            ).length;
                                          } else {
                                            // count words by whitespace for non-CJK (English/other)
                                            count = str
                                              .split(/\s+/)
                                              .filter(Boolean).length;
                                          }
                                          const color = count <= 250 ? 'red' : '#222';
                                          return (
                                            <small
                                              style={{ color, fontWeight: 600 }}
                                            >
                                              {count}/250
                                            </small>
                                          );
                                        })()}
                                      </div>
                                    </div>
                                  </div> */}

                                  <div className="form-row">
                                    <div
                                      className="col-12"
                                      style={{ fontWeight: 700 }}
                                    >
                                      <FormGroup
                                        name="links"
                                        // label="作品雲端連結*"
                                        label={
                                          <>
                                            作品雲端連結*
                                            <div
                                              style={{
                                                fontSize: 13,
                                                fontWeight: 400,
                                                color: '#666',
                                                marginTop: 8,
                                                lineHeight: '1.4',
                                              }}
                                            >
                                              <div>連結內須包含以下文件：</div>
                                              <div>
                                                （1）多媒體作品或網上問答遊戲公開訪問連結
                                              </div>
                                              <div>（2）作品介紹檔案</div>
                                              <div>
                                                （3）相關附件
                                                (如影片作品之字幕稿、網上問答遊戲之題目及答案等)
                                              </div>
                                            </div>
                                          </>
                                        }
                                        style={{ backgroundColor: '#F2F2FF' }}
                                        disabled={disabled}
                                      />
                                    </div>
                                  </div>
                                  {!themeReport && (
                                    <div className="form-row">
                                      <div className="col-12 d-flex justify-content-center">
                                        <button
                                          className="btn"
                                          disabled={formDisabled}
                                        >
                                          {formDisabled ? (
                                            <img src="assets/img/submit-disabled.svg" />
                                          ) : (
                                            <img src="assets/img/submit.svg" />
                                          )}
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                  {themeReport && (
                                    <div className="form-row">
                                      <div className="col-12 d-flex justify-content-center">
                                        <img src="assets/img/submitted.svg" />
                                      </div>
                                    </div>
                                  )}
                                </>
                              );
                            }}
                          </PageHttp>
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </div>
            {showConfirm && (
              <div
                className="modal"
                style={{
                  display: 'block',
                  background: 'rgba(0,0,0,0.3)',
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  width: '100vw',
                  height: '100vh',
                  zIndex: 1050,
                  overflow: 'auto',
                }}
              >
                <div
                  className="modal-dialog"
                  style={{
                    maxWidth: 400,
                    margin: '80px auto',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <div
                    className="modal-content"
                    style={{
                      borderRadius: '12px',
                      boxShadow: '0 4px 24px rgba(41,104,177,0.12)',
                      padding: '32px 24px 24px 24px',
                      position: 'relative',
                      background:
                        'linear-gradient(0deg, #FFFFFF, #FFFFFF), linear-gradient(180deg, rgba(41, 104, 177, 0.2) 0%, rgba(255, 255, 255, 0.2) 41.48%)',
                    }}
                  >
                    {/* Close button */}
                    <button
                      type="button"
                      className="close"
                      aria-label="Close"
                      onClick={handleCancel}
                      style={{
                        position: 'absolute',
                        top: 16,
                        right: 16,
                        fontSize: 24,
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        color: '#1C64D0',
                        zIndex: 2,
                      }}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    {/* Modal content */}
                    <div
                      style={{
                        textAlign: 'center',
                        fontSize: '18px',
                        fontWeight: 600,
                        color: '#222', // black text
                        marginBottom: '32px',
                        marginTop: '8px',
                      }}
                    >
                      比賽只可提交一次，確定提交？
                    </div>
                    {/* Buttons */}
                    <div
                      className="d-flex justify-content-center"
                      style={{ gap: '24px' }}
                    >
                      <button
                        type="button"
                        className="btn"
                        onClick={handleCancel}
                        style={{
                          borderRadius: '39px',
                          border: '1px solid #1C64D0',
                          color: '#1C64D0',
                          background: '#fff',
                          fontWeight: 600,
                          minWidth: '96px',
                          padding: '8px 0',
                        }}
                      >
                        取消
                      </button>
                      <button
                        type="button"
                        className="btn"
                        onClick={handleConfirm}
                        style={{
                          borderRadius: '39px',
                          background: '#1C64D0',
                          color: '#fff',
                          fontWeight: 600,
                          minWidth: '96px',
                          padding: '8px 0',
                          border: 'none',
                          marginLeft: '8px',
                        }}
                      >
                        確定
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="col-12 col-md-4 col-lg-4 mb-4">
              <div className="row d-flex flex-column">
                <div className="col">
                  <GroupInfo />
                </div>
                <div className="col">
                  <div className="mt-3">
                    <button
                      type="button"
                      className="btn btn-primary btn-lg btn-block d-flex align-items-center"
                      style={{
                        backgroundColor: '#1C64D0',
                        borderColor: '#1C64D0',
                        borderRadius: '12px',
                        padding: '12px 16px',
                        height: '64px',
                      }}
                      onClick={downloadRequirement}
                      aria-label="下載比賽要求PDF"
                    >
                      <div
                        className="d-flex align-items-center"
                        style={{ width: 40, height: 40 }}
                      >
                        <div
                          style={{
                            width: 40,
                            height: 40,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: 'rgba(255,255,255,0.08)',
                            borderRadius: 8,
                          }}
                        >
                          <img
                            src="assets/img/pdf.svg"
                            style={{ width: 24, height: 24 }}
                          />
                        </div>
                      </div>

                      <div
                        className="flex-fill text-center"
                        style={{ fontSize: 18, fontWeight: 700, color: '#fff' }}
                      >
                        比賽要求PDF
                      </div>

                      <div>
                        <div
                          style={{
                            width: 42,
                            height: 42,
                            background: '#2058C8',
                            borderRadius: 10,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <FA icon={faDownload} style={{ color: '#fff' }} />
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormThemeReportsManagement;
